import { Component } from '@angular/core';
import { ActivatedRoute, Params, Router, RouterOutlet } from '@angular/router';
import { OepaUserAccount } from '@ohioepa/oepa-common-lib';
import { OepaIopAuthLibService } from '@ohioepa/oepa-iop-auth-lib';
import { OepaUserAccountService } from '@ohioepa/oepa-ui-lib';
import { ToastrService } from 'ngx-toastr';
import { intLiveReloadAccount } from './int-live-reload-account';
import { extLiveReloadAccount } from './ext-live-reload-account';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'OEPA_401_ui';

  constructor(private route: ActivatedRoute, private router: Router,
    private authService: OepaIopAuthLibService,
    private toastr: ToastrService,
    private userAccountService: OepaUserAccountService) {
  }

  ngOnInit() {
    this.getEbizVersion();
    this.route.queryParams.subscribe((params: Params) => {
      this.getQueryParameters(params);
      let loginInitialized = sessionStorage.getItem('LOGIN_INITIALIZED');
      if (!loginInitialized) {
        this.loadApp(params);
      }
      if (params['code']) {
        this.login();
      }
    });
  }

  private initalLogin() {
    this.authService.configureOAuth();
    setTimeout(() => {
      this.authService.login();
      sessionStorage.setItem('LOGIN_INITIALIZED', 'true');
    }, 1000)
  }

  async login() {
    this.authService.configureOAuth();
    setTimeout(async () => {
      let authenticated: Promise<boolean> = this.authService.tryLogin();
      if (await authenticated) {
        this.retrieveUserInfo();
      }
    }, 500);
  }

  private retrieveIOPUserAccount(userID: string) {
    this.userAccountService.setAuthToken(this.authService.getAccessToken());
    this.userAccountService.retrieveAccountForUser(userID, 'DSW_401').subscribe({
      next: (account: OepaUserAccount) => {
        if (account) {
          this.initializeUserAccount(account);
        } else {
          console.log('No account found');
        }
      }, error: err => {
        this.toastr.error('Initialization error: ' + err, 'ERROR');
      }
    });
  }
  
    private retrieveLiveReloadAccount() {
      sessionStorage.setItem('LOGIN_INITIALIZED', 'true');
      let liveReloadAccount = this.getEnv() === 'DSW_401' ? intLiveReloadAccount : extLiveReloadAccount;
      let overrrideUserID = this.getUserID();
      if (overrrideUserID) {
        liveReloadAccount.loginName = overrrideUserID;
        liveReloadAccount.accountID = overrrideUserID;
      }
      this.userAccountService.setLiveReloadUser(liveReloadAccount).subscribe(() => {
          this.userAccountService.retrieveAccountForCurrentUser('DSW_401').subscribe({
            next: (account: OepaUserAccount) => {
              if (account) {
                this.initializeUserAccount(account);
                this.userAccountService.userAccount$.next({});
              } else {
                console.log('No account found');
              }
            }, error: err => {
              this.toastr.error('Initialization error: ' + err, 'ERROR');
            }
          });
      });
    }

  private retrieveEBizUserAccount(userID: string) {
    this.userAccountService.retrieveAccountForUser(userID, 'DSW_401').subscribe({
      next: (account: OepaUserAccount) => {
        if (account) {
          this.initializeUserAccount(account);
        } else {
          console.log('No account found');
        }
      }, error: err => {
        this.toastr.error('Initialization error: ' + err, 'ERROR');
      }
    });
  }

  private initializeUserAccount(account: OepaUserAccount) {
    if (account) {
      this.userAccountService.setCurrentUserAccount(account);
      this.routeToApplication();
    } else {
      console.log('No account found');
    }
  }

  retrieveUserInfo() {
    this.authService.userProfile$.subscribe((profile) => {
      this.retrieveIOPUserAccount(this.getUserID());
    });
  }

  private loadApp(params: Params) {
    if (this.isLocalDevelopment()) {
      this.retrieveLiveReloadAccount();
    } else {
      if (this.getLoginParam()) {
        this.retrieveEBizUserAccount(this.getLoginParam());
      } else if (this.getUserID()) {
        let loginInitialized = sessionStorage.getItem('LOGIN_INITIALIZED');
        if (!loginInitialized) {
          this.initalLogin();
        }
      }
    }
  }

  private isLocalDevelopment(): boolean {
    return (window.location.href.indexOf('localhost') > -1 && window.location.href.indexOf('7001') < 0);
  }

  private getQueryParameters(params: Params) {
    if (params['env']) {
      this.setEnv(params['env']);
    }
    if (params['uid']) {
      this.setUserID(params['uid']);
    }
    if (params['login']) {
      this.setLoginParam(params['login']);
    }
  }

  ngOnDestroy(): void {
    sessionStorage.clear();
  }

  private routeToApplication() {
    this.router.navigate([this.getEnv() || 'ext'], { queryParams: { uid: this.getUserID() } });
  }

  private setEnv(env: string) {
    sessionStorage.setItem('env', env);
  }

  private getEnv(): string {
    return sessionStorage.getItem('env') || '';
  }

  private setUserID(userID: string) {
    sessionStorage.setItem('USER_ID', userID);
  }

  private getUserID(): string {
    return sessionStorage.getItem('USER_ID') || '';
  }

  private setLoginParam(loginParam: string) {
    sessionStorage.setItem('LOGIN_PARAM', loginParam);
  }

  private getLoginParam(): string {
    return sessionStorage.getItem('LOGIN_PARAM') || '';
  }

  private getEbizVersion() {
    this.userAccountService.getEBizVersion('DSW_401').subscribe(ebizVersion => {
      if (ebizVersion) {
        sessionStorage.setItem('EBIZ_VERSION', ebizVersion);
      }
    })
  }
}
